import { render, staticRenderFns } from "./Scorte.vue?vue&type=template&id=18aa361e&"
import script from "./Scorte.vue?vue&type=script&lang=js&"
export * from "./Scorte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports